// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-BsObjectSection-BsObjectSection-module__attrBox--o8yao {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.src-businessServices-BsObjectSection-BsObjectSection-module__onNewLine--ngXmh {
  grid-column: 1;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/BsObjectSection/BsObjectSection.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACA;EACE,cAAA;AACF","sourcesContent":[".attrBox {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.onNewLine {\n  grid-column: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attrBox": `src-businessServices-BsObjectSection-BsObjectSection-module__attrBox--o8yao`,
	"onNewLine": `src-businessServices-BsObjectSection-BsObjectSection-module__onNewLine--ngXmh`
};
export default ___CSS_LOADER_EXPORT___;
